




















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Mutation, State, Getter, Action } from 'vuex-class';
import {
  IEmployee,
  ICompanyType,
  IUserRole,
  IUserType,
  IUser,
  IPosition,
} from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'employee';
const ns = { namespace };

@Component
export default class EmployeeDetail extends BaseDetail<IEmployee> {
  @Prop({ default: () => ({}) }) readonly preDefinedValues: any;
  namespace = namespace;
  positions = [];
  types = [];
  @State('entities', ns) entities: Record<string, IEmployee>;
  @State('currentUser', { namespace: 'user' }) currentUser: IUser;
  @State('roles', ns) roles: IUserRole;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('getUserRoles', ns) getUserRoles: any;
  @Action('getUserTypes', ns) getUserTypes: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  created() {
    this.client
      .get('/position/all')
      .then(({ data }) => (this.positions = data));
  }
  mounted() {
    this.loadEntity();
    if (this.preDefinedValues) {
      for (const [key, value] of Object.entries(this.preDefinedValues)) {
        this.setValue(this.entityPatch, key, value);
      }
    }
  }
  afterMounted() {
    this.getUserRoles();
    this.getUserTypes();
  }
}
